import { combineReducers } from 'redux';
import { ShippingOrdersReducer } from './ExportLists/services/reducer';

export const documentModuleReducer = combineReducers({
  ShippingOrdersReducer,
});

export type DocumentModuleReducer = ReturnType<typeof documentModuleReducer>;
